// src/utils/tokenLoader.js

import jwtDecode from "jwt-decode";
import { useCallback, useContext, useEffect } from "react";
import { UserContext } from "../components/auth/auth-context";
import { useSelectedBusiness } from "../redux/store";
import { GET_TOKEN } from "../graphql/queries/generic";
import { useLazyQuery } from "@apollo/client";
import { getToken as getStoredToken, setToken } from "./authUtils";

export const useTokenLoader = () => {
  const { providerUser, updateProviderUser } = useContext(UserContext);
  const selectedBusiness = useSelectedBusiness();
  const businessId = selectedBusiness?.businessBasic?.id || "";
  let storedUser = null;
  try {
    const storedToken = getStoredToken();
    storedUser = storedToken ? jwtDecode(storedToken) : null;
  } catch (_error) {
    storedUser = null;
  }
  const userId = providerUser?.userId || storedUser?.userId || null;

  const [getToken, { loading, error, data }] = useLazyQuery(GET_TOKEN, {
    fetchPolicy: "network-only",
  });

  const trigger = useCallback(
    (options = {}) => {
      let currentStoredUser = storedUser;
      try {
        const storedToken = getStoredToken();
        currentStoredUser = storedToken ? jwtDecode(storedToken) : storedUser;
      } catch (_error) {
        currentStoredUser = storedUser;
      }

      return getToken({
        ...options,
        variables: {
          userId: providerUser?.userId || currentStoredUser?.userId || null,
          staffId: null,
          subscriptionId: null,
          businessId: Number(businessId),
          ...(options.variables || {}),
        },
      });
    },
    [businessId, getToken, providerUser?.userId, storedUser],
  );

  useEffect(() => {
    if (!loading && !error && data?.getToken?.token) {
      const token = data.getToken.token;
      setToken(token);
      const decoded = jwtDecode(token);
      updateProviderUser(decoded);
    }
  }, [loading, error, data]);

  return {
    loading,
    error,
    trigger,   // call trigger() to fetch
    token: data?.getToken?.token || null,
  };
};
